import { Markdown } from '@cadstrom/sigma-engine-shared';

import { JsonBodyRemarkPlugin } from './markdown-plugins-utils.js';
import { SigmaModelSignalPinsTableMarkdownItem } from './sigma-model-signal-pins-table-markdown-item.js';

import type { RemarkMarkdownDirectiveDefinition } from './markdown-plugins-utils.js';

/** Directive name used in markdown container blocks: `:::sigma-model-signal-pins-table` */
export const SIGMA_MODEL_SIGNAL_PINS_TABLE_DIRECTIVE = Markdown.SIGMA_MODEL_SIGNAL_PINS_TABLE_DIRECTIVE;

/**
 * Remark plugin definition for the `sigma-model-signal-pins-table` container directive.
 *
 * The directive body must be a JSON array of sigma model signal pins rows; the raw JSON string is
 * passed to {@link SigmaModelSignalPinsTableMarkdownItem} via the `jsonData` prop.
 *
 * Usage in markdown:
 * ```
 * :::sigma-model-signal-pins-table
 * [{"rowKey":"d","modelSignalName":"Drain","block":null,"datasheetName":"DRAIN","pins":["2"]}]
 * :::
 * ```
 */
export const sigmaModelSignalPinsTableDirectiveDefinition: RemarkMarkdownDirectiveDefinition = {
	allowedAttributes: ['jsonData'],
	directive: JsonBodyRemarkPlugin(SIGMA_MODEL_SIGNAL_PINS_TABLE_DIRECTIVE),
	item: SigmaModelSignalPinsTableMarkdownItem,
};
